module.exports = __webpack_public_path__ + "img/1560944302.b1f961bc.jpg";